import React, { useState } from "react";

import UploadPhoto from "../../icons/upload-photo";

import Img from "./Img";

const FileImg = ({ name, src }) => {
  const [img, setImg] = useState({ preview: "", raw: "" });

  const handeFileChange = ({ target }) => {
    {
      target.files.length &&
        setImg({
          preview: URL.createObjectURL(target.files[0]),
          name: target.files[0].name,
        });
    }
  };

  return (
    <div className="file-img">
      <label className="input-img">
        <input type="file" id={name} name={name} onChange={handeFileChange} />
        <i>
          <UploadPhoto />
        </i>
        <Img src={img.preview || src} border={true} />
      </label>
      <label htmlFor={name}>اپلود عکس</label>
    </div>
  );
};

export default FileImg;
